export default __webpack_public_path__ + "static/media/six_of_pentacles.134c3340.png";